import React from 'react';

export const Footer = ({ footerLinks }) => {
  return (
    <div
      style={{
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingBottom: '20px',
        backgroundColor: '#16223e'
      }}
      id="footerLinks"
    >
      {footerLinks != null &&
        Object.keys(footerLinks).map(key => {
          const title = key;
          const links = footerLinks[key]['links'];
          const linkLength = links.length;
          return (
            <div className="appendBottom5 paddingT10 whiteText">
              <h2 className="font14 latoBlack paddingT10 paddingB5">{title}</h2>
              {links.map(({ text, onclickUrl }, idx) => {
                return (
                  <a
                    className="whiteText font12 lineHeight16"
                    href={onclickUrl}
                  >
                    {idx === linkLength - 1 ? text : `${text}, `}
                  </a>
                );
              })}
            </div>
          );
        })}
    </div>
  );
};
